import { OktaContext } from '@okta/okta-react';
import { useBoolean } from 'ahooks';
import { FC, useContext, useEffect } from 'react';
import { AuthenticationServiceProvider } from 'api/account';
import { PageLoading } from 'components/atoms/loading';
import { LS_TEMPLATE_ID_KEY } from 'constant';
import { useQueryParams } from 'hooks/use-query-params';
import { useAccountMetaQuery } from 'queries';
import { logger } from 'services';

export const SessionLogin: FC<React.PropsWithChildren<unknown>> = () => {
  const oktaAuth = useContext(OktaContext)?.oktaAuth;
  const params = useQueryParams();
  const sessionToken = params.get('token');
  const templateId = params.get('templateId');
  const { data: accountMeta } = useAccountMetaQuery();

  const [isSessionLoading, { setTrue, setFalse }] = useBoolean(false);

  useEffect(() => {
    if (
      accountMeta?.okta.authenticationServiceProvider ===
      AuthenticationServiceProvider.COGNITO
    ) {
      if (templateId) {
        localStorage.setItem(LS_TEMPLATE_ID_KEY, templateId);
      }
      setTrue();
      window.location.href = `${
        window.location.origin
      }/login?token=${sessionToken}&cognito=${true}`;
    } else if (templateId === undefined || templateId === null) {
      if (sessionToken && oktaAuth) {
        setTrue();
        oktaAuth.token
          .getWithRedirect({ sessionToken, prompt: 'none' })
          .catch((error) => {
            logger.error('token setup failed', { error });
            setFalse();
          });
      }
    } else if (sessionToken && oktaAuth) {
      localStorage.setItem(LS_TEMPLATE_ID_KEY, templateId);
      setTrue();
      oktaAuth.token
        .getWithRedirect({
          sessionToken,
          prompt: 'none',
          extraParams: { templateId },
        })
        .catch((error) => {
          logger.error('token setup failed', { error });
          setFalse();
        });
    }
  }, [setTrue, setFalse, oktaAuth, sessionToken, templateId, accountMeta]);

  if (isSessionLoading) {
    return <PageLoading />;
  }

  return null;
};
